import { MtPackage } from "server/models"
import {
    OrderType,
    KeyValue,
    inferLiteral,
} from "client/utils"
import * as types from "./types"


export const setPackageList = (packageList: types.PackageList) => ({
    type: inferLiteral(types.PACKAGE_LIST),
    packageList,
})
export const setPackageIds = (packageIds: readonly number[]) => ({
    type: inferLiteral(types.PACKAGE_IDS),
    packageIds,
})
export const setPackageEdit = (packg: MtPackage) => ({
    type: inferLiteral(types.PACKAGE_EDIT),
    package: packg,
})
export const setPackageSettings = (settings: KeyValue<types.PackageSettings>) => ({
    type: inferLiteral(types.PACKAGE_SETTINGS),
    settings,
})
export const setPackageAllowed = (packageAllowed: types.PackageAllowedList) => ({
    type: inferLiteral(types.PACKAGE_ALLOWED),
    packageAllowed,
})
export const setPackageActiveCell = (activeCell: types.PackageActiveCell) => ({
    type: inferLiteral(types.PACKAGE_ACTIVE_CELL),
    activeCell,
})
export const setPackageSort = (sortColumn: keyof MtPackage, sortOrder: OrderType) => ({
    type: inferLiteral(types.PACKAGE_SORT),
    sortColumn,
    sortOrder,
})
export const setPackageFilters = (filters: types.PackageFilters) => ({
    type: inferLiteral(types.PACKAGE_FILTERS),
    filters,
})
export const setPackageReloadList = (value: boolean) => ({
    type: inferLiteral(types.PACKAGE_RELOAD_LIST),
    value,
})
export const setPackageReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.PACKAGE_RELOAD_EDIT),
    value,
})
